import { apiClient } from "../client";
const ENDPOINTS = {
    LIST: "/sites",
};
export const sitesService = {
    getSites: (filters = {}) => {
        const params = new URLSearchParams();
        if (filters.search)
            params.append("search", filters.search);
        if (filters.buildingType)
            params.append("buildingType", filters.buildingType);
        if (filters.companyName)
            params.append("companyName", filters.companyName);
        if (filters.page)
            params.append("page", filters.page.toString());
        if (filters.pageSize)
            params.append("pageSize", filters.pageSize.toString());
        return apiClient.get(`${ENDPOINTS.LIST}?${params.toString()}`);
    },
    getSite: (siteId) => apiClient.get(`/sites/${siteId}`),
    createSite: (data) => apiClient.post(ENDPOINTS.LIST, data),
    updateSite: (siteId, data) => apiClient.put(`/sites/${siteId}`, data),
    deleteSite: (siteId) => apiClient.delete(`/sites/${siteId}`),
    // Work items
    updateWorkItems: (siteId, workItems) => apiClient.put(`/sites/${siteId}/work-items`, workItems),
    // Versions
    getVersions: (siteId) => apiClient.get(`/sites/${siteId}/versions`),
    createVersion: (siteId) => apiClient.post(`/sites/${siteId}/versions`),
    getVersion: (siteId, versionId) => apiClient.get(`/sites/${siteId}/versions/${versionId}`),
    getDefaultWorkItems: () => apiClient.get('/sites/default-work-items'),
    // Duplicates
    getDuplicateSites: () => apiClient.get('/sites/duplicates'),
    mergeDuplicateSites: (targetSiteId, sourceSiteIds) => apiClient.post('/sites/duplicates/merge', {
        targetSiteId,
        sourceSiteIds,
    }),
};
